import { v4 as uuid } from "uuid";

type AlertData = {
  type?: "success" | "info" | "critical";
  message: string;
};

type Alert = {
  id: string;
} & AlertData;

type ListenerCallback = (alerts: Alert[]) => void;

let store: Store | undefined;
let alerts: Alert[] = [];

class Store {
  #listeners: ListenerCallback[] = [];

  constructor() {
    if (store) {
      throw new Error("Can only have one alert store");
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    store = this;
  }

  register(callback: ListenerCallback) {
    if (!this.#listeners.includes(callback) && typeof callback === "function") {
      this.#listeners.push(callback);
    }
  }

  unregister(callback: ListenerCallback) {
    this.#listeners = this.#listeners.filter(
      (listener) => listener !== callback,
    );
  }

  updateListeners() {
    this.#listeners.forEach((callback) => callback(alerts));
  }

  addAlert(alert: AlertData): string {
    const id = uuid();
    alerts.push({ id, ...alert });
    this.updateListeners();

    return id;
  }

  removeAlert(idToRemove: string) {
    alerts = alerts.filter(({ id }) => id !== idToRemove);
    this.updateListeners();
  }

  clearAlerts() {
    alerts = [];
    this.updateListeners();
  }

  getAlerts(): Alert[] {
    return alerts;
  }
}

const storeSingle = Object.freeze(new Store());

export default storeSingle;
